import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
import { API_URL, APP_VERSION, ENABLE_LOGS, healthCheck } from "./lib/api-client";

document.title = "WorkView Pro";

if (ENABLE_LOGS) {
  console.info(`[workview] build version: ${APP_VERSION}`);
  console.info(`[workview] API base URL: ${API_URL}`);

  void healthCheck()
    .then((data) => {
      console.info("[workview] API health check succeeded", data);
    })
    .catch((error: unknown) => {
      console.error("[workview] API health check failed", error);
    });
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
